# Quick Start

Get your first component rendering in minutes.

## Install

Install the package in your project:

```bash
npm install aiapp-ui
```

AI App Design components use Tailwind CSS for styling. Make sure Tailwind is configured in your project.

## Add a component

Each component can be installed individually from the registry:

```bash
npx aiapp-ui add approval-card
```

This adds the component source to your project at `components/aiapp-ui/approval-card/`.

## Define a backend tool

Create a tool on your server that returns data matching the component's schema:

```typescript
const tools = {
  approveDeployment: {
    description: "Ask user to approve or reject a deployment",
    parameters: z.object({
      title: z.string(),
      description: z.string(),
    }),
    execute: async ({ title, description }) => ({
      title,
      description,
      actions: [
        { id: "approve", label: "Approve", variant: "primary" },
        { id: "reject", label: "Reject", variant: "destructive" },
      ],
    }),
  },
};
```

## Register the renderer

Map the tool name to the component in your client toolkit:

```tsx
import { ApprovalCard } from "@/components/aiapp-ui/approval-card";

export const toolkit = {
  approveDeployment: {
    render: ({ result }) => <ApprovalCard {...result} />,
  },
};
```

When the model calls `approveDeployment`, the result is parsed and rendered as a styled approval card in the conversation.

## Next steps

- [Design Guidelines](/docs/design-guidelines) -- understand the design constraints for chat UI
- [Actions](/docs/actions) -- how interactive components feed decisions back to the assistant
- [Receipts](/docs/receipts) -- permanent records of user decisions
